module.exports = __webpack_public_path__ + "media/images/shared/icon-additional-professors-white-4057d04a42df2c4f1ef1c91ed80a71ea.png";